const Label = ({ text, htmlFor, children, className = '', noMargin, light }) => {
	return (
		<label htmlFor={htmlFor} className={`${className} ${noMargin ? '' : 'mb-1'} ${light ? 'text-white' : 'text-gray-900'} text-sm inline-block font-semibold `}>{children ? children : text }</label>
	)
}

export default Label